// src/features/tidsregistering/services/registrations.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/registrations';

export const registrationsAPI = {
  clockIn: (data) =>
    apiClient.post(`${BASE}/clock-in`, data),

  clockOut: (registrationId, data) =>
    apiClient.post(`${BASE}/${registrationId}/clock-out`, data),

  createManual: (data) =>
    apiClient.post(`${BASE}/manual`, data),

  getRegistration: (registrationId) =>
    apiClient.get(`${BASE}/${registrationId}`),

  listForDate: (staffMemberId, date) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}/date/${date}`),

  listForDepartmentDate: (date) =>
    apiClient.get(`${BASE}/department/date/${date}`),

  updateRegistration: (registrationId, data) =>
    apiClient.put(`${BASE}/${registrationId}`, data),

  deleteRegistration: (registrationId) =>
    apiClient.delete(`${BASE}/${registrationId}`),
};
